const d =
	'm336-288 144-144 144 144 48-48-144-144 144-144-48-48-144 144-144-144-48 48 144 144-144 144 48 48ZM189-98q-37.175 0-64.088-26.912Q98-151.825 98-189v-582q0-37.588 26.912-64.794Q151.825-863 189-863h582q37.588 0 64.794 27.206Q863-808.588 863-771v582q0 37.175-27.206 64.088Q808.588-98 771-98H189Z';

export default d;
